var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Egypt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb300",
    d: "M29,27.75c0,0.693-0.557,1.25-1.25,1.25L24,26.5L20.25,29C19.557,29,19,28.443,19,27.75v-5.488 c0-0.693,0.557-1.25,1.25-1.25h7.5c0.693,0,1.25,0.557,1.25,1.25V27.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb300",
    d: "M22.75,29h2.5L24,26.5L22.75,29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb300",
    d: "M24,23L24,23c-0.552,0-1-0.448-1-1v-2c0-0.552,0.448-1,1-1h0c0.552,0,1,0.448,1,1v2 C25,22.552,24.552,23,24,23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Egypt);
export default __webpack_public_path__ + "static/media/icons8-egypt.fe9715ce24983a721b22be3bb617cccc.svg";
export { ForwardRef as ReactComponent };